import { PaperDetails } from "helpers/api";
import useLabels from "hooks/useLabels";
import Quartile from "./Quartile";

interface JournalDetailsProps {
  journal: PaperDetails["journal"];
  hideSJR?: boolean;
}

export const JournalDetails = ({ journal, hideSJR }: JournalDetailsProps) => {
  const [emptyJournalName] = useLabels("screens.details.empty-journal-name");

  return (
    <div className="flex flex-col items-start">
      <p data-testid="journal-title" className="lg-md">
        {journal.title ?? emptyJournalName}
      </p>
      <div className="flex flex-col w-full gap-y-3">
        {!hideSJR && <Quartile quartile={journal.scimago_quartile ?? null} />}
      </div>
    </div>
  );
};
